import module from './module.js'

import './components/empleado/agregar/component.js'
import './components/empleado/seleccionar/component.js'
import './directives/idNominaExisteValidator/idNominaExisteValidator.js'
import './routes/nominas.js'

export default module.name



// WEBPACK FOOTER //
// ./src/nominas/shared/index.js